import { RFQStatusComp } from "./RFQStatusComp";

export default RFQStatusComp;
